import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";
import { Methods } from "../shared/methods";

@Injectable({
  providedIn: "root",
})
export class DinamictextService {
  public mtds: Methods = new Methods();
  public url: string;
  public urlUser: string;
  public token;
  public headers;
  public company_id_usuario_logueado;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token"));
    this.company_id_usuario_logueado = JSON.parse(
      localStorage.getItem("companyId")
    );
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  save(id, type: string, text: string): Observable<any> {
    if (id) {
      return this.edit(id, type, text);
    } else {
      return this.create(type, text);
    }
  }

  saveEspecificadminedit(field, value): Observable<any> {
    const json = { field: field, value: value };
    return this.petition(this.url + "/company/especificadminedit", json);
  }

  getDetailSetup(): Observable<any> {
    return this.petition(
      `${this.url}/company/detailsetup/${this.company_id_usuario_logueado}?page=1`
    );
  }

  create(type: string, text: string): Observable<any> {
    const json = { type, data: text };
    return this.petition(this.url + "/dynamictext/new", json);
  }

  edit(id, type: string, text: string): Observable<any> {
    const json = { type, data: text };
    return this.petition(this.url + "/dynamictext/edit/" + id, json);
  }

  list(type, apitoken = null): Observable<any> {
    if (!apitoken) {
      const identity = JSON.parse(localStorage.getItem("identity"));
      apitoken = identity.apiCompany;
    }
    const json = { type, apitoken };
    return this.petition(this.url + "/dynamictext/list", json);
  }

  getImagesUserType(id, type): Observable<any> {
    let params = "authorization=" + this.token + "&type=" + type;
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http
      .post(this.url + "/image/detailusertype/" + id + "?page=1", params, {
        headers: headers,
      })
      .pipe(map((res) => res));
  }

  petition(url, json = null, type = null): Observable<any> {

    this.token = JSON.parse(localStorage.getItem('token'));
    
    let paramas, response;
    paramas = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      paramas = paramas + "&json=" + json;
    }

    if (type != null) {
      paramas = paramas + "&type=" + type;
    }

    response = this._http
      .post(url, paramas, { headers: this.headers })
      .pipe(map((res) => res));

    if (response.code === 404) {
      this.mtds.notifyError("Your session has expired");
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    }

    return response;
  }
}
